// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"128":"13799bdd","245":"9b8a1bba"}[chunkId] + ".chunk.js";
};